import { Link } from '~components'
import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Images } from '~data'
import Footer from "./style"
export default function FooterFive(){
return(
    <Footer backgroundColor="#f3f4f6">
    <Container>
        <Footer.Box pb="25px">
        <Row className="justify-content-center justify-content-lg-between">
            <Col xs="12">
            <Footer.Logo>
                {/* Brand Logo*/}
                <Footer.Box mb="30px">
                    <Link  to="#">
                        <img src={Images.FooterSix.LogoBlack} alt="logo" />
                    </Link>
                </Footer.Box>
            </Footer.Logo>
            
            <Footer.Text as="p">Каждый должен научиться программировать, потому что это учит нас думать.</Footer.Text>
            <Footer.Menu>
                <Footer.MenuItems><a href="/">Главная страница</a></Footer.MenuItems>
                <Footer.MenuItems> <a href="/about/about-us">О нас</a> </Footer.MenuItems>
                {/* <Footer.MenuItems><a href="/about/testimonials-1">Отзывы</a></Footer.MenuItems> */}
                <Footer.MenuItems><a href="https://t.me/nextgen_admin">Помощь</a></Footer.MenuItems>
                {/* <Footer.MenuItems><a href="#">Contact</a>
                </Footer.MenuItems> */}
            </Footer.Menu>
            </Col>
        </Row>
        </Footer.Box>
        <Footer.Copyright>
        <Footer.SocialShare>
            <Footer.SocialShareItem>
                <a href="https://facebook.com/nextgen.uz">
                <i className="fab fa-facebook-square" />
                </a>
            </Footer.SocialShareItem>
            <Footer.SocialShareItem>
                <a href="https://t.me/nextgen_uz">
                <i className="fab fa-telegram" />
                </a>
            </Footer.SocialShareItem>
            <Footer.SocialShareItem>
                <a href="https://instagram.com/nextgen.uz">
                <i className="fab fa-instagram" />
                </a>
            </Footer.SocialShareItem>
            <Footer.SocialShareItem>
                <a href="https://linkedin.com/company/nextgen-uz">
                <i className="fab fa-linkedin" />
                </a>
            </Footer.SocialShareItem>
        </Footer.SocialShare>
        <Footer.CopyrightText>© 2021 Next Generation. All Rights Reserved</Footer.CopyrightText>
        </Footer.Copyright>
    </Container>
    </Footer>
)
}